var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row pull-left d-flex align-items-center"},[_c('div',{staticClass:"col-12 participant-name"},[_vm._v(" "+_vm._s(_vm.participant.about)+" ")]),_c('participant-category-list',{attrs:{"participant":_vm.participant}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }